import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchJob } from '#/modules/orgDashboard/api/listing/orgDashboardApiFetchJob';
import { orgDashboardRepostJobRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardRepostJobPageLoadable } from './OrgDashboardRepostJobPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, jobId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardRepostJobRoute>) {
  const [job] = await Promise.all([
    orgDashboardApiIsomorphicFetchJob({ request, context })(orgId, jobId),
    OrgDashboardRepostJobPageLoadable.load(),
  ]);

  return { job };
}

export default function OrgDashboardRepostJobHorizonRoute({
  loaderData: { job },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Repost a Job Listing')}>
      <OrgDashboardRepostJobPageLoadable job={job} />
    </RouteModule>
  );
}
